module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Steve Anderson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" Steve Anderson is the author of the Kaspar Brothers novels: "), _c('I', [_vm._v("The Losing Role")]), _vm._v(", "), _c('I', [_vm._v("Liberated")]), _vm._v(", and "), _c('I', [_vm._v("Lost Kin")]), _vm._v("; "), _c('I', [_vm._v("Under False Flags ")]), _vm._v("is the prequel to his latest novel, "), _c('I', [_vm._v("The Preserve")]), _vm._v(". Anderson was a Fulbright Fellow in Germany and is a literary translator of bestselling German fiction as well as a freelance editor. He lives in Portland, Oregon. "), _c('BR'), _vm._v("   ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/d4G1Or/tc-custom/9781504084895.jpg?1726574123239",
      "alt": "This image is the cover for the book Losing Role, The Kaspar Brothers"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Losing Role, The Kaspar Brothers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A German actor conscripted into WWII will play the role of his life as he makes a daring escape in this espionage thriller inspired by true events.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" When the SS orders banned entertainer Max Kaspar to impersonate a US officer during the Battle of the Bulge, Max devises his own secret mission to escape the war and flee to America. With his career in Germany over, this plan is his big break—and his last chance."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" But Max’s mission is doomed from the start. Trapped between the lines in the freezing Ardennes Forest, he must summon all of his acting talents and newfound courage to evade perilous traps laid by both sides. Inspired by a real-life 1944 operation, this gripping wartime thriller is the first book in the Kaspar Brothers series.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0